import * as taskName from './task-name'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { createUIDefinition } from '../default-task-definition'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import {
    selectIsImplantTreatmentQuotationReadyForPurchase,
    selectTreatmentQuotation,
} from '../../../../treatment/state/quotation/selector'
import { IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT } from '../../../../anamnesis/state/anamnesis/const'

export default createUIDefinition({
    taskName: taskName.IMPLANT_CREATE_TREATMENT_QUOTATION,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.IMPLANT_TREATMENT_PLAN_UPLOAD_WIDGET,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.IMPLANT_TREATMENT_QUOTATION_WIDGET,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
            widgetProps: {
                excludeTemplateKeyList: [
                    IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT
                ],
            },
        },
        {
            component: processUI.ANAMNESIS_EDIT_WIDGET_CONTAINER,
            widgetProps: {
                templateKey: IMPLANT_TREATMENT_PHYSICIAN_ASSESSMENT,
            },
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
            readOnly: true,
            widgetProps: {

            },
        },
    ],
    actionList: [
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
    ],
    taskValidatorSelector: [
        selectTreatmentQuotation,
        selectIsImplantTreatmentQuotationReadyForPurchase,
    ],
    taskValidator: (task, processInstance, taskName, eventName, treatmentQuotation, readyForPurchase) => {
        if (eventName !== 'treatment_quotation_created') {
            return null
        }
        const messageList = []

        if (!treatmentQuotation) {
            messageList.push(createValidationMessage('No treatment quotation created', 'validateTreatmentQuotation.object'))
            return messageList
        }

        if (!readyForPurchase) {
            messageList.push(createValidationMessage('Treatment Quotation not valid', 'validateTreatmentQuotation.valid'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/implant-plan/implant-create-treatment-quotation.js